import { Breadcrumb } from "antd";
import React from "react";

import styles from "@/components/common/Breadcrumb/breadcrumb.module.css";
import { IMAGES } from "@/constant";

interface BreadcrumbItem {
  label: string;
  withArrow?: boolean;
  onClick?: () => void;
  replayPrivacy?: "allow";
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbProps> = ({ items }) => {
  const hasBack = items?.some((item) => item.withArrow);

  const breadcrumbItems = items.map((item) => ({
    title: (
      <span
        onClick={item.onClick}
        data-dd-privacy={item.replayPrivacy}
        className={`${styles.breadcrumb_text} ${item.onClick ? styles.pointer : styles.default}`}
      >
        {item.withArrow && (
          <img
            aria-label="breadcrumb-back"
            src={IMAGES.BACK_BUTTON}
            className={styles.back_button}
          />
        )}
        {item.label}
      </span>
    ),
  }));

  return (
    <div className={`${hasBack && styles.customBreadcrumb}`}>
      <Breadcrumb separator=">" items={breadcrumbItems} />
    </div>
  );
};

export default Breadcrumbs;
